type ChatEditingMessageProps = {
  className: string;
  isEditing: boolean;
};

export const ChatEditingMessage: React.FC<ChatEditingMessageProps> = ({ className, isEditing }) => {
  return isEditing && <div className={className}>メッセージ編集中</div>;
};
